import debug from 'debug';

import { getScrollToParam } from './pageNavigation';
import { scrollNavigation } from './scrollToComponent';

const debugLog = debug('app:scroll-from-url');

/**
 * Handles scroll-to-component based on URL parameters
 * Should be called after page navigation completes
 */
export const handleScrollFromUrl = async (): Promise<void> => {
    const scrollToComponentId = getScrollToParam();

    if (!scrollToComponentId) {
        return;
    }

    // Wait for page to be fully rendered, then scroll
    await scrollNavigation.scrollAfterNavigation(scrollToComponentId);

    // Clean up URL by removing the scrollTo parameter
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete('scrollTo');
        window.history.replaceState({}, '', url.toString());
    } catch (error) {
        debugLog('Failed to clean up URL:', error);
    }
};
